import { nanpPostalCodePattern } from "@homeinstead/locale";
import { z } from "zod";
import { email } from "~www/types/forms/schemas/email";
import { phone } from "~www/types/forms/schemas/phone";

const customerServiceFormSchema = z.object({
  emailAddress: email,
  feedback: z.string().refine((val) => val.trim().length > 0, {
    error: "Please enter your feedback",
  }),
  firstName: z.string().refine((val) => val.trim().length > 0, {
    error: "First name is required",
  }),
  franchise: z.string().min(1, { error: "Please select a franchise" }),
  lastName: z
    .string()
    .refine((val) => val.trim().length > 0, { error: "Last name is required" }),
  optInEmail: z.boolean().default(true),
  phoneNumber: phone,
  postalCode: z.string().regex(nanpPostalCodePattern, {
    error: "Please enter a valid US ZIP or Canadian postal code",
  }),
  smsConsent: z.boolean().default(false),
});

type CustomerServiceFormData = z.input<typeof customerServiceFormSchema>;

type CustomerServiceFeedbackErrorKind =
  | "exception-error"
  | "server-error"
  | "validation-error";

export type { CustomerServiceFeedbackErrorKind, CustomerServiceFormData };

export { customerServiceFormSchema };
